function parse(value) {
  if (typeof value !== 'string') return value
  try { return JSON.parse(value) } catch (_) { return null }
}
const positiveInteger = value => (typeof value === 'number' && Number.isSafeInteger(value) && value > 0) ||
  (typeof value === 'string' && /^[1-9]\d*$/.test(value) && Number.isSafeInteger(Number(value)))
const skuKey = value => (typeof value === 'string' && /^[1-9]\d*$/.test(value)) ||
  (typeof value === 'number' && Number.isSafeInteger(value) && value > 0) ? String(value) : null
const text = value => typeof value === 'string' && value.trim() ? value : null

// A display projection only. Never append these rows to the order/fulfillment data.
export function pendingOrderGifts(form, fulfillmentGifts, loaded, loadFailed) {
  const result = { rows: [], message: '' }
  if (!form || (form.state !== 1 && form.state !== '1')) return result
  if (form.activityRewardLoadFailed) return { ...result, message: '活动赠品记录读取失败，请重新打开订单详情。' }
  const records = form.activityRewardLogList
  if (!Array.isArray(records)) return { ...result, message: '活动赠品信息未返回，暂无法确认待发放赠品。' }
  const pending = records.filter(record => record && (record.status === 0 || record.status === '0'))
  const physical = pending.filter(record => record.rewardType === 'GOODS')
  const unknown = pending.some(record => !record.rewardType) || records.some(record => !record)
  if (!physical.length) return { ...result, message: unknown ? '部分赠品信息未完整记录，请核对下方活动赠送记录。' : '' }
  if (loadFailed) return { ...result, message: '订单商品信息读取失败，暂无法确认待发放赠品，请重新打开详情。' }
  if (!loaded) return result
  const existing = new Set((fulfillmentGifts || []).map(row => skuKey(row.combineId)).filter(Boolean))
  let incomplete = unknown, overlap = false
  physical.forEach(record => {
    const detail = parse(record.rewardDetail)
    const snapshot = parse(record.ruleSnapshot)
    const candidates = snapshot && Array.isArray(snapshot.gifts) ? snapshot.gifts : []
    if (!Array.isArray(detail) || !detail.length) { incomplete = true; return }
    detail.forEach(item => {
      const key = item && skuKey(item.skuId)
      if (!key || !positiveInteger(item.num)) { incomplete = true; return }
      // Existing persisted gifts are authoritative; do not guess residual quantities.
      if (existing.has(key)) { overlap = true; return }
      const saved = candidates.find(candidate => candidate && skuKey(candidate.skuId) === key) || {}
      result.rows.push({ name: text(saved.goodsName) || `赠品规格${key}`, spec: text(saved.spec) || text(saved.specTitle) || '规格未记录',
        combineId: key, combineCount: item.num, jushuitanCode: '未记录', pendingPreview: true })
    })
  })
  const messages = []
  if (incomplete) messages.push('部分赠品明细未记录或无法读取，请核对下方活动赠送记录。')
  if (overlap) messages.push('已有订单赠品明细的规格未重复列出待发放数量，请核对下方活动赠送记录。')
  result.message = messages.join(' ')
  return result
}
